import { Record as record } from 'immutable';
import { BulletinSeverity } from '../constants/AppConstants';

const defaults = {
    id: null,
    category: null,
    severity: null,
    title: null,
    description: null,
    url: null
};

// The JP API can send either a single `url` or an Odyssey-style `urls` array
// of { target: 'Website' | 'CallCentre', link } entries
const pickUrl = (urls) => {
    if (!Array.isArray(urls)) {
        return null;
    }
    const withLink = urls.filter(url => url?.link);
    const website = withLink.find(url => url.target === 'Website');
    return (website || withLink[0])?.link ?? null;
};

class Bulletin extends record(defaults) {
    static fromJSON (json = {}) {
        return new Bulletin({ ...json, url: json.url || pickUrl(json.urls) });
    }

    isP1 () {
        return this.severity === BulletinSeverity.P1;
    }
}

export default Bulletin;
